import { render, staticRenderFns } from "./Aside.vue?vue&type=template&id=2128fb5e&scoped=true&"
import script from "./Aside.vue?vue&type=script&lang=ts&"
export * from "./Aside.vue?vue&type=script&lang=ts&"
import style0 from "./Aside.vue?vue&type=style&index=0&id=2128fb5e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2128fb5e",
  null
  
)

export default component.exports